module.exports = __webpack_public_path__ + "static/media/Savings_Diagram_Mobile_AE_EN.d703370d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Savings_Diagram_Mobile_AE_EN.png
// module id = 561
// module chunks = 0